/* eslint-disable eqeqeq */
import * as React from "react";
import {AdminEntityService} from "../../../services/AdminEntityService";
import {ListRequest} from "../../../http/protocol";
import {DataTable, DataTableAction, Renderer} from "./DataTable";
import {PagerModel} from "./PagerModel";
import {toPathParams} from "../../../util/UrlUtils";
import {ColumnType} from "./ColumnType";

interface Props {
    nameResource? : string;
    service? : AdminEntityService<any>;
    listRequest : ListRequest;
    columns: Array<{ property : string, name : string, renderer?: Renderer<any>, className? : string, orderBy? : string, type? : ColumnType}>;
    onPagerChange : (pager : PagerModel) => void;
    onAction : (item : any, actionId : string) => undefined | Promise<any>;
    actions? : Array<DataTableAction>;
    showIndex? : boolean;
    onResults? : (result : any) => void;
    disableInitialSearch? : boolean;
    title?: string;
    hideTitle? : boolean;
    setMaxLimit?:number;
    customRequest?: ( listRequest: ListRequest) => undefined | Promise<any>;
    autoRefreshOptions?: number[];
}
interface State {
    items? : any[];
    pager? : PagerModel;
    loading? : boolean;
    removed? : number[];
    itemsUpdating? : number[];
    pagerOffsetPlaceholder: string;
    timeIntervalId?: number;
}
export class EntityDataTable extends React.Component<Props,State>{
    mounted? : boolean = false;
    constructor(props : Props) {
        super(props);
        let pager = new PagerModel();
        let listRequest = props.listRequest;
        if(listRequest.orderBy) {
            pager.orderBy = listRequest.orderBy;
        }
        if(listRequest.ascending != null) {
            pager.ascending = listRequest.ascending;
        }
        if(listRequest.offset) {
            pager.offset = listRequest.offset;
        }
        if(listRequest.limit) {
            pager.limit = listRequest.limit;
        }
     

        this.state = { items : [], pager : pager, loading : false, removed : [], itemsUpdating : [], pagerOffsetPlaceholder: ""+Math.floor(pager.offset/pager.limit + 1)};
    }
    componentDidMount() {
        this.mounted = true;
        if(!this.props.disableInitialSearch) {
            this.doSearch();
        }
    }
    componentWillUnmount() {
        this.mounted = false;
        if(this.state.timeIntervalId) clearInterval(this.state.timeIntervalId);

    }

    componentDidUpdate(previousProps : Props, previousState : State) {
        let prev = toPathParams(previousProps.listRequest);
        let current = toPathParams(this.props.listRequest);
        if(prev != current ) {
            this.doSearch();
        }
    }
    
    async doSearch() {
        console.log("DO SEARCH ", this.props);
        if(this.props.service == null && this.props.customRequest === null) {
            return;
        }
        this.setState({loading : true, removed : []});
        if(this.props.listRequest) {
            
            let listRequest = this.props.listRequest;
            try{
                let listResponse = this.props.customRequest && 
                    await this.props.customRequest(listRequest) || 
                    await this.props.service!.list(listRequest);

                let pager = new PagerModel(this.state.pager, (listResponse.nrOfResults || listResponse["total"]));
                let list : any[] = listResponse["items"] || listResponse["values"];
                if(this.mounted == true) {
                    this.setState({ items : list, pager : pager});
                    if(this.props.onResults) {
                        this.props.onResults(listResponse);
                    }
                }
            } catch (error){
                console.error("There was a problem calling the seach function:", error)
            } finally {
                if(this.mounted == true) {
                    setTimeout(()=>{ this.setState({ loading : false}); }, 1000);
                }
            }
        }
    }

    onAction(item : any, id : string, index : number) : Promise<any> | undefined {
        let result : undefined | Promise<any> = this.props.onAction(item,id);
        if(typeof result != "undefined" && id == "delete") {
            let promise  = (result as Promise<{}|any>);
            this.state.itemsUpdating && this.state.itemsUpdating.push(index);
            this.setState({itemsUpdating : this.state.itemsUpdating})
            return promise.then( () => {
                this.state.removed && this.state.removed.push(index);
                this.state.itemsUpdating && this.state.itemsUpdating.splice(this.state.itemsUpdating.indexOf(index), 1);
                this.setState( { removed :  this.state.removed, itemsUpdating : this.state.itemsUpdating });
            }).catch(()=>{
                this.state.itemsUpdating  && this.state.itemsUpdating.splice(this.state.itemsUpdating.indexOf(index), 1);
                this.setState( { itemsUpdating : this.state.itemsUpdating });
            });
        }
        if(typeof result !== "undefined" && id == "refresh") {
            result.then(item => {
                if(this.state.items !== undefined){
                    let items = this.state.items;
                    items[index] = item; //Update offer id bonus history
                    this.setState({
                        items:items
                    })
                }
            })
        }
        if(typeof result !== "undefined" && id == "block") {
            let items = [...this.state.items!];
            let itemUpdate = {...items[index]};
            if(itemUpdate['blocked']===true){
                itemUpdate['blocked']=false;
            }
            else if(itemUpdate['blocked']===false){
                itemUpdate['blocked']=true;
            }
            items[index] = itemUpdate;
            this.setState({
                items:items
            })
        }
    }

    onPagerChange(pager : PagerModel) {
        this.setState({pager : pager});
        this.props.onPagerChange && this.props.onPagerChange(pager);
    }

    onAutoRefreshChange(value: number | undefined){
        console.log("Auto refresh change: " + value);
        let timeIntervalId = this.state.timeIntervalId;
        if(timeIntervalId){
            clearInterval(timeIntervalId);
            timeIntervalId = undefined;
        }
        if(value && this.props.autoRefreshOptions){
            this.doSearch(); 
            timeIntervalId = setInterval(()=>{ 
                console.log("Running auto refresh call");
                if(!this.state.loading) this.doSearch(); 
            }, value * 1000);
        }
        this.setState({timeIntervalId: timeIntervalId});
    }

    getStateFromPager(pager: PagerModel): State {
        return {pagerOffsetPlaceholder: ""+Math.floor(pager.offset/pager.limit + 1), pager:pager};
    }

    render() {
        return (
            <div className={"card-box"}>

                {!this.props.hideTitle && (
                    <h4 className={"header-title"}>{this.props.title ? this.props.title : "Results"}</h4>
                )}
                <DataTable  onAction={this.onAction.bind(this)}
                            onPagerChange={this.onPagerChange.bind(this)}
                            items={this.state.items ? this.state.items : []}
                            columns={this.props.columns}
                            pager={this.state.pager ? this.state.pager : new PagerModel()}
                            loading={this.state.loading}
                            actions={this.props.actions}
                            removed={this.state.removed}
                            itemsUpdating={this.state.itemsUpdating ? this.state.itemsUpdating : []}
                            showIndex={this.props.showIndex}
                            setMaxLimit={this.props.setMaxLimit}
                            nameResource={this.props.nameResource}
                            autoRefreshOptions={this.props.autoRefreshOptions}
                            onAutoRefreshChange={this.onAutoRefreshChange.bind(this)}
                />

            </div>

        );
    }



}
